export const SET_CHANGE_HISTORY = 'changeHistory/SET_CHANGE_HISTORY';
export const SET_WAITING = 'changeHistory/SET_WAITING';
